import jsPDF from 'jspdf';
import { addLogoToPDF } from './pdfLogoHelper';

export interface DarbReportHeaderOptions {
  title: string;
  subtitleLines?: string[];
  /** Y position where table/content should start */
  contentStartY?: number;
}

const COMPANY_LINES = [
  'DARB NATIONAL SERVICE LLC',
  'P.O Box 417, PC 100, Muscat, Sultanate of Oman',
  'Phone: +968 24790888 | Email: info@darbns.com',
  'CR: 1366462',
];

/**
 * Adds DARB logo + standardized company header to PDF reports.
 * Returns the Y position where main content (tables) should begin.
 */
export async function addDarbReportHeader(
  doc: jsPDF,
  options: DarbReportHeaderOptions
): Promise<number> {
  await addLogoToPDF(doc);

  const pageWidth = doc.internal.pageSize.getWidth();
  const centerX = pageWidth / 2;

  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 0);
  doc.text(COMPANY_LINES[0], centerX, 38, { align: 'center' });

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text(COMPANY_LINES[1], centerX, 45, { align: 'center' });
  doc.text(COMPANY_LINES[2], centerX, 51, { align: 'center' });
  doc.text(COMPANY_LINES[3], centerX, 57, { align: 'center' });

  doc.setFontSize(15);
  doc.setFont('helvetica', 'bold');
  doc.text(options.title, centerX, 67, { align: 'center' });

  let y = 74;
  if (options.subtitleLines?.length) {
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    options.subtitleLines.forEach((line) => {
      doc.text(line, centerX, y, { align: 'center' });
      y += 5;
    });
    y += 3;
  } else {
    y = 72;
  }

  return options.contentStartY ?? Math.max(y, 72);
}

export const PDF_TABLE_HEAD_STYLES = {
  fillColor: [30, 30, 30] as [number, number, number],
  textColor: 255,
  fontStyle: 'bold' as const,
  fontSize: 8,
};
